'use strict'

import apiBaseUrl from "./apiBaseUrl";

const urlBase = apiBaseUrl(window.location.origin);

export const PastOrderService = {
    pastOrders: (number, unit, accessToken) => {
        const baseUrl = urlBase + "/livetracking";
        const url = `${baseUrl}/pastOrders/${number}/${unit}`;
        const options = {
            method: 'GET',
            headers: {
                'Content-Type': "application/json",'Accept': "application/json",
                'Authorization': accessToken
            }
        };
        return fetch(url, options)
            .then(response => {
                if(response.status == 401) {
                    // window.location = '/';
                    window.location = '/dashboard?token=1';
                }
                return response.json();
            }).catch(error => {
                return error;
            });
    }
};


// WEBPACK FOOTER //
// ./src/service/pastOrderService.js